module.exports = __webpack_public_path__ + "media/images/microbius-logo-ng-1fdcb0e751be031bfc1a133e2a6b86d2.png";